import React, { useRef, useState, useReducer } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import {
  WysiwygField,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';


import './style.scss';

const CrisisBanner = ({ entity }) => {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const resizing = useRef(true);

  const { t } = useTranslation();
  const body = entity.getIn(['body', 0, 'processed'], '');
  const bannerTimeStamp = entity.getIn(['changed', 0, 'value'], '');

  const bannerCloseTimeStamp = Cookies.get('bannerCloseTimeStamp');
  const [height, setHeight] = useState(false);

  const dismissCookie = () => {
    Cookies.set('bannerCloseTimeStamp', bannerTimeStamp);
    forceUpdate();
  };

  if (bannerCloseTimeStamp >= bannerTimeStamp) {
    return null;
  }

  setTimeout(() => {
    setHeight(true);
  }, 100);

  const triggerResize = () => {
    if (resizing.current) {
      window.dispatchEvent(new Event('resize'));
      setTimeout(() => triggerResize(), 40);
    }
  };

  return (
    <AnimateHeight
      duration={300}
      height={height ? 'auto' : 0}
      // Trigger window resize during resizing, to fix stuttering Lotties
      onAnimationStart={() => triggerResize()}
      onAnimationEnd={
        () => {
          resizing.current = false;
          setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
        }
      }
    >
      <div className="NodeCrisisBanner row" id="CrisisBanner">
        <div className="NodeCrisisBanner__text col-10 col-lg-8">
          <WysiwygField
            property="schema:text"
            html={body}
          />
        </div>
        <div className="NodeCrisisBanner__close col-2 col-lg-4">
          <Button onClick={dismissCookie}>
            <div className="NodeCrisisBanner__close_content">
              <div className="NodeCrisisBanner__close_text">
                {t('crisis_banner.close_notification')}
              </div>
              <div className="icon icon-cross icon-after" />
            </div>
          </Button>
        </div>
      </div>
    </AnimateHeight>
  );
};

export default CrisisBanner;
